import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

export function AddAccidentIncidentReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/accidents-and-incidents`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.ACCIDENTS_INCIDENTS}
      backPath={backPath}
    />
  );
}
